import React, { useContext, useState } from 'react';
import { map } from 'lodash';
import classnames from 'classnames';
import renderRawHtml from '../../common/render_raw_html';
import { LineDataContext, SetContext, PageContext } from '../../common/contexts';
import { Header } from '../../common/header';
import { Subheader } from '../../common/subheader';
import { AllPlansInclude } from '../../common/allPlansIncluded';
import CharacteristicList from '../../common/characteristicList';
import { ChoosePerkPack } from '../components/choose_perk_pack';

const OverviewPlan = ({
  plan, onPlanSelect, toCompare
}) => {
  const lazyInitSelectedPack = () => {
    const initial = plan.choosePerkPack?.find((pack) => pack.defaultSelected);
    return initial ? initial.id : null;
  };
  const [ selectedPack, setSelectedPack ] = useState(lazyInitSelectedPack);
  const selectPack = (id) => {
    setSelectedPack(id);
  };
  const { delayAnimation } = useContext(SetContext);
  const {
    getClickedSelectButton,
    setClickedSelectButton
  } = useContext(PageContext);
  const { setLoading } = useContext(LineDataContext);
  const clickedSelectButton = getClickedSelectButton();

  const clickSelectButton = (event, plan) => {
    setClickedSelectButton(plan.id);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setClickedSelectButton(null);
      // Changing state after onPlanSelect for the last line will raise
      // memory leaking message from react
      const currentPack = selectedPack;
      setSelectedPack(lazyInitSelectedPack);
      onPlanSelect(event, plan, currentPack);
    }, delayAnimation);
  };

  return (
    <div className="overview-list_item -flex">
      {plan.rateLabel && (
        <div className="overview-list_top-label">{plan.rateLabel}</div>
      )}
      <div className="plan-short">
        <h2 className="plan-short_title ng-binding" { ...renderRawHtml(plan.name) } />
        <div className="plan-short_description" { ...renderRawHtml(plan.description) } />
        <div className="plan-short_pricing">
          <div className="plan-short_pricing-grid">
            <h2 className="plan-short_pricing-value">${ plan.price }</h2>
            <div className="plan-short_pricing-hint">
              <div className="plan-short_pricing-hint-line">/line per month</div>
              <div className="plan-short_pricing-hint-line">{ plan.taxPhrase }</div>
            </div>
          </div>
        </div>
      </div>
      <div className="plan-features -flex">
        <CharacteristicList
          title={ plan.featuresTitle }
          list={ plan.features }
        />
        {plan.savings?.length > 0 && (
          <CharacteristicList
            title={ plan.savingsTitle }
            list={ plan.savings }
            onCheck
          />
        )}
        {plan.perks?.length > 0 && (
          <CharacteristicList
            title={ plan.perksTitle }
            list={ plan.perks }
            note={ plan.perksNote }
            overTitle={ plan.id !== 1
              ?  plan.overTitle || 'Plan perks'
              : null }
            specialClassList={ plan.id === 1 ? '-first-col-2' : null }
            highlighted={ plan.id !== 1 }
          />)
        }
        {
          plan.choosePerkPack?.length > 0 && (
            <ChoosePerkPack
              perkPacks={ plan.choosePerkPack }
              selected={ selectedPack }
              onSelectPack={ selectPack }
            />
          )
        }
        {
          plan.other?.length > 0 &&
          <CharacteristicList
            list={ plan.other }
          />
        }
      </div>
      <div className="plan-buttons -flex">
        <div className="plan-buttons_item">
          <button
            className={
              classnames(
                'button -full-width plan-select-button',
                { '-clicked': clickedSelectButton }
              )
            }
            onClick={ (event) => { clickSelectButton(event, plan); } }
            disabled={ clickedSelectButton && clickedSelectButton !== plan.id }
          >
            Select
          </button>
        </div>
        <div className="plan-buttons_item">
          <button
            className="button-link"
            onClick={ (event) => { toCompare(event, plan.id, selectedPack); } }
          >
            Compare
          </button>
        </div>
      </div>
    </div>
  );
};

const OverviewPage = ({ updatedCurrentLine, onPlanSelect, toCompare }) => {
  const { plans } = useContext(LineDataContext);
  return (
    <div className="content">
      <Header />
      <Subheader currentLine={ updatedCurrentLine } />
      <div className="tabs">
        <div className="tab -active">Overview</div>
        <div className="tab" onClick={ () => {toCompare();} }>Compare</div>
      </div>
      <div className="overview-page">
        <div className="inner-content -flex">
          <AllPlansInclude />
          <div className="overview-list">
            {
              map(plans, (plan) => {
                return (
                  <OverviewPlan
                    key={ `overviewPlanItem${plan.id}` }
                    plan={ plan }
                    onPlanSelect={ onPlanSelect }
                    toCompare={ toCompare }
                  />
                );
              })
            }
          </div>
        </div>
        <footer className="footer">
          <span className="footer_item">Important plan information</span>
          <span className="footer_item">Important broadband information</span>
        </footer>
      </div>
    </div>
  );
};

export default OverviewPage;
